import { get_session9cytjmfbg8nd as get_session } from '../../../../../sdk/UserSession.mjs';
import {
  await1kke5zj2piplv as await_0,
  awaitOnce2ui7qqi9bvdeq as awaitOnce,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  LineItem2rt64afaiyloc as LineItem,
  ScopeView2pjeasrtqdymw as ScopeView,
  Specification3fgfbf7ihgj8v as Specification,
} from '../../../../../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializerOrContextual1whp5jyfp32aq as serializerOrContextual } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/SerializationHelpers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { DataClassPathSelf9694s3fei65z as DataClassPathSelf } from '../../../../../../../../lightning-server-shared/com/lightningkite/serialization/DataClassPath.mjs';
import {
  get_project15zbqkhtwq5i6 as get_project,
  get_order2yr4ophs8mhb3 as get_order,
} from '../../../../../../../../crowpay-shared/com/crowpay/LineItemFields.mjs';
import { eq1298m2cje971u as eq } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/ConditionBuilder.mjs';
import { SortBuilder2qc3a7b1bw9uz as SortBuilder } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/SortBuilder.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Query38t34cs21ulcf as Query } from '../../../../../../../../lightning-server-shared/com/lightningkite/lightningdb/Query.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import {
  to2cs3ny02qtbcb as to,
  Paire9pteg33gng7 as Pair,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import {
  sortedWith2csnbbb21k0lg as sortedWith,
  filterNotNull3qfgcwmxhwfxe as filterNotNull,
  plus310ted5e4i90h as plus,
  toSet2orjxp16sotqu as toSet,
  plus20p0vtfmu0596 as plus_0,
  contains2gm06f5aa19ov as contains,
  sorted354mfsiv4s7x5 as sorted,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { compareValues1n2ayl87ihzfk as compareValues } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/comparisons/Comparisons.mjs';
import { modify2eca96i8s7hc2 as modify } from '../../../../../../../../reactive/com/lightningkite/reactive/extensions/helpers.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  KtList3hktaavzmj137 as KtList,
  Collection1k04j3hzsbod0 as Collection,
  KtMap140uvy3s5zad8 as KtMap,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsNarrow26l63sh4olw2h as get_viewIsNarrow,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../../../nav/crowpay.mjs';
import {
  equals2au1ep9vhcato as equals,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { SharedUtils_getInstanceggolgle4lzs6 as SharedUtils_getInstance } from '../../../../../../../../crowpay-shared/com/crowpay/sharedUtils.mjs';
import { addAll1k27qatfgp3k5 as addAll } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/MutableCollections.mjs';
import {
  checkCountOverflow1ro2fe1r4xvgf as checkCountOverflow,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  setOf1u3mizs95ngxo as setOf,
  listOfvhqybd2zx248 as listOf,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../../../selectedContractor.mjs';
import { NewTasksFromSpecsDialogooupp0z882ky as NewTasksFromSpecsDialog } from '../../../../dialogs/NewTasksFromSpecsDialog.mjs';
import {
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  timesx4ey3un7ihw1 as times,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
  Dimensions32ju1l7z4mh as Dimension,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  reorderts8zja415q79 as reorder,
  forEachMaybeReorderableDestroying35lnn8f9ey87k as forEachMaybeReorderableDestroying,
  forEachMaybeReorderable1aeoqjpfy2fje as forEachMaybeReorderable,
} from '../../../reordering.mjs';
import { pushChanges1lnw8bjwewvzf as pushChanges } from '../../../../../utils/Draft.ext.mjs';
import { AdjustedLineItemjcq04uf63gb9 as AdjustedLineItem } from '../../../../../utils/AdjustedLineItem.mjs';
import {
  Subscopelwws6cwdmjzk as Subscope,
  CreateScopeViewDialog2bw9ryrzjhk1t as CreateScopeViewDialog,
  NewScopeViewDialog2llneu31ficjx as NewScopeViewDialog,
} from '../../../../dialogs/NewScopeViewDialog.mjs';
import { Draft3jz09icer2h2u as Draft } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Draft.mjs';
import { plus2lr02ok6jhhxu as plus_1 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { resolveProjectAttachments1r3ylk2p3xmwv as resolveProjectAttachments } from '../../../files/attachmentFilePreview.mjs';
import { StringBuildermazzzhj6kkai as StringBuilder } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/StringBuilderJs.mjs';
import {
  confirmationDialog1lynowl7yd4cd as confirmationDialog,
  GenericConfirmationDialog172k63mmx5r2d as GenericConfirmationDialog,
} from '../../../../dialogs/GenericConfirmationDialog.mjs';
import {
  plus1ogy4liedzq5j as plus_2,
  minus165a8u1e0x1lu as minus,
} from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/collections/_Sets.mjs';
import { EditScopeViewDialog24e1qiqowum8p as EditScopeViewDialog } from '../../../../dialogs/EditScopeViewDialog.mjs';
import {
  DeleteButtonSemantic_getInstance1x6fgyalib897 as DeleteButtonSemantic_getInstance,
  get_textButtonybbt8y3eu5hx as get_textButton,
  get_secondaryButtondor94xxt3ws3 as get_secondaryButton,
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_tertiaryButton1h22y4lorv47t as get_tertiaryButton,
} from '../../../../theming/buttons.mjs';
import { createReorderModssndd63zi2ijm as createReorderMods } from '../../../../../../../../crowpay-shared/com/crowpay/Reorderable.mjs';
import { FunctionAdapter3lcrrz3moet5b as FunctionAdapter } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/FunctionAdapter.mjs';
import { Comparator2b3maoeh98xtg as Comparator } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/ComparatorJs.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance_0 } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  get_expanding10cuv3ua9vajx as get_expanding,
  get_centered1xfu6or5nc0lq as get_centered,
  get_atEnd1cw5d2zgug26 as get_atEnd,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  RowOrCol3a33s3yce2tuv as RowOrCol,
  Frame1e7t2kcdb3wu7 as Frame,
  RowCollapsingToColumn13iucsgmjquhb as RowCollapsingToColumn,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { lens27v59dqa1oc3r as lens } from '../../../../../../../../reactive/com/lightningkite/reactive/lensing/abstracts.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { get_lightSection4cpu8okr0w14 as get_lightSection } from '../../../../theming/sections.mjs';
import { IconView32wln42r1v8cb as IconView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/IconView.commonHtml.mjs';
import {
  get_dragHandlemufcu3tsewag as get_dragHandle,
  get_exportFile2180aovih5s3c as get_exportFile,
  get_edit2tiiawv2658bs as get_edit,
  get_trash3qsdn4kaynjmu as get_trash,
} from '../../../../../icons.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  get_rem2p56fiaxda5jo as get_rem,
  get_dp28ag147e4p5cz as get_dp,
  get_rem14pbkv8p42gid as get_rem_0,
  get_px8ok5q0jdway2 as get_px,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { DragShadow11keb9piinnfw as DragShadow } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/models/DragData.mjs';
import {
  reactiveScope1fcalsbdr0hgb as reactiveScope,
  reactive2pl1t9wy5gll5 as reactive,
} from '../../../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import { shownWhenxgf1ujy6rmvr as shownWhen } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { scopeSetIcon1d64me82i5zfn as scopeSetIcon } from '../../../iconShortcuts.mjs';
import { TextViewe6rp77b08kos as TextView } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/TextView.commonHtml.mjs';
import {
  BodySemantic_getInstancembkce4y4wobt as BodySemantic_getInstance,
  BoldSemantic_getInstance3sy4hmow8wwn9 as BoldSemantic_getInstance,
  body3i5t0n7zprpqb as body,
} from '../../../../theming/Titles.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  MonetaryValue__plus_impl_c1ylt2px1svctotw0g as MonetaryValue__plus_impl_c1ylt,
  MonetaryValue__toString_impl_xslc771noy15rjps4pw as MonetaryValue__toString_impl_xslc77,
} from '../../../../../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import { Button263cw152yl80e as Button } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import {
  resize3py5p2yrjp6p7 as resize,
  lensFilter5xvs6ea8thrl as lensFilter,
} from '../../../../../utils/utils.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import {
  Indent_HalfSection_getInstance3e9u4kbpkw4rx as Indent_HalfSection_getInstance,
  indented3383b46h9g40w as indented,
  indentedExact2f1prym8qlwxs as indentedExact,
} from '../../../space.mjs';
import {
  get_unpadded3gipn3ftxgnwh as get_unpadded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { ReactiveState__getOrNull_impl_1asnfp2wx27g6rqhoxq as ReactiveState__getOrNull_impl_1asnfp } from '../../../../../../../../reactive/com/lightningkite/reactive/core/ReactiveState.mjs';
import {
  Companion_getInstance3n9as6ds1py67 as Companion_getInstance_1,
  UUID21wrnrlmk5y1y as UUID,
} from '../../../../../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { CoroutineScopefcb5f5dwqcas as CoroutineScope } from '../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { ViewWriter2xfqkrnuqv5cx as ViewWriter } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/ViewWriter.mjs';
import { Movepj4bxmsunu5w as Move } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/forEachReorderable.mjs';
import { greySeparatory5mpcoeivng5 as greySeparator } from '../../../../theming/separators.mjs';
import { charSequenceLength3278n89t01tmv as charSequenceLength } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { get_project2bky694b9ef47 as get_project_0 } from '../../../../../../../../crowpay-shared/com/crowpay/ScopeViewFields.mjs';
import { mutableRememberSuspending34dudnx7ur0xn as mutableRememberSuspending } from '../../../../../../../../reactive/com/lightningkite/reactive/core/MutableRememberSuspending.mjs';
import { EditLineItem2agpgpyrr30uy as EditLineItem } from './EditLineItem.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../../nav/AppDimensions.mjs';
import { Spaceoq5xo9lsieqc as Space } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Space.commonHtml.mjs';
import { get_compact3lsezez8nz8b6 as get_compact } from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/views/themeDerivations.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { Form39thjb3imm7id as Form } from '../../../nav/header.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $this$mutableRememberSuspending, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().efg_1;
  // Inline function 'com.lightningkite.lightningdb.condition' call
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_1 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$1 = isInterface(tmp_1, KSerializer()) ? tmp_1 : THROW_CCE();
  // Inline function 'kotlin.let' call
  var it = new (DataClassPathSelf())(tmp$ret$1);
  var tmp_2 = eq(get_project(it), $this.mho_1.dho_1);
  // Inline function 'com.lightningkite.lightningdb.sort' call
  // Inline function 'kotlin.apply' call
  var this_1 = new (SortBuilder())();
  // Inline function 'com.lightningkite.lightningdb.path' call
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$6 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var it_0 = new (DataClassPathSelf())(tmp$ret$6);
  this_1.m4a(get_order(it_0));
  var tmp$ret$11 = this_1.o1r();
  var tmp_4 = tmp_0.jfm(new (Query())(tmp_2, tmp$ret$11), $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  // Inline function 'kotlin.collections.map' call
  var this_2 = tmp_4;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$12 = to($this.mho_1.nho(item), item.o6k_1);
    destination.v(tmp$ret$12);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_5 = EditLineItems$forms$slambda$lambda;
  var tmp$ret$15 = new (sam$kotlin_Comparator$0_0())(tmp_5);
  // Inline function 'kotlin.collections.map' call
  var this_3 = sortedWith(destination, tmp$ret$15);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(this_3, 10));
  var _iterator__ex2g4s_0 = this_3.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$17 = item_0.af_1;
    destination_0.v(tmp$ret$17);
  }
  return destination_0;
}
function EditLineItems$forms$slambda$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.bf_1;
  var tmp$ret$1 = b.bf_1;
  return compareValues(tmp, tmp$ret$1);
}
function *_generator_invoke__zhh2q8_0($this, fs, $completion) {
  // Inline function 'kotlin.collections.filter' call
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = fs.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = element.chn_1;
    var tmp = await_0(this_0, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    if (!tmp.g6k_1.equals($this.oho_1)) {
      destination.v(element);
    }
  }
  return destination;
}
function *_generator_invoke__zhh2q8_1($this, $this$EditLineItem, formId, $completion) {
  var tmp = modify($this.pho_1.kho_1, EditLineItems$createForm$slambda$slambda_0(formId), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var EditLineItems$createForm$slambda$slambdaClass;
function EditLineItems$createForm$slambda$slambda() {
  if (EditLineItems$createForm$slambda$slambdaClass === VOID) {
    class $ {
      constructor($formId) {
        this.oho_1 = $formId;
      }
      qho(fs, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this, fs), $completion);
      }
      s2(p1, $completion) {
        return this.qho((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$createForm$slambda$slambdaClass = $;
  }
  return EditLineItems$createForm$slambda$slambdaClass;
}
function EditLineItems$createForm$slambda$slambda_0($formId) {
  var i = new (EditLineItems$createForm$slambda$slambda())($formId);
  var l = (fs, $completion) => i.qho(fs, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = render$_anonymous_$_anonymous_$createScopeView_9n5ywx($this.rho_1, true, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.xgd(tmp_0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_3($this, $completion) {
  var tmp = get_dialogStack();
  var tmp_0 = render$_anonymous_$_anonymous_$createScopeView_9n5ywx($this.sho_1, false, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  tmp.xgd(tmp_0);
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_4($this, map, $completion) {
  var tmp;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!map.i1()) {
    var tmp_0;
    var tmp_1 = $this.tho_1.uho($completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    if (tmp_1) {
      tmp_0 = true;
    } else {
      var tmp_2 = $this.tho_1.vho($completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  if (tmp) {
    var tmp_3 = $this.tho_1.hho_1(null, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s = map.d2().m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_0 = $this.tho_1.kho_1;
    var tmp_4 = await_0(this_0, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    // Inline function 'kotlin.collections.mapNotNull' call
    var tmp0 = tmp_4;
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var destination_0 = ArrayList().w();
    // Inline function 'kotlin.collections.forEach' call
    var _iterator__ex2g4s_0 = tmp0.m1();
    while (_iterator__ex2g4s_0.n1()) {
      var element_0 = _iterator__ex2g4s_0.o1();
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_1 = element_0.chn_1;
      var tmp_5 = await_0(this_1, $completion);
      if (tmp_5 === get_COROUTINE_SUSPENDED())
        tmp_5 = yield tmp_5;
      // Inline function 'kotlin.takeIf' call
      var this_2 = tmp_5;
      var tmp_6;
      var tmp0_safe_receiver = element.e2();
      if (equals(this_2.j6k_1, tmp0_safe_receiver == null ? null : tmp0_safe_receiver.k7z_1)) {
        tmp_6 = this_2;
      } else {
        tmp_6 = null;
      }
      var tmp0_safe_receiver_0 = tmp_6;
      if (tmp0_safe_receiver_0 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        destination_0.v(tmp0_safe_receiver_0);
      }
    }
    var tmp$ret$13;
    $l$block: {
      // Inline function 'kotlin.collections.maxOfOrNull' call
      var iterator = destination_0.m1();
      if (!iterator.n1()) {
        tmp$ret$13 = null;
        break $l$block;
      }
      var maxValue = iterator.o1().o6k_1;
      while (iterator.n1()) {
        var v = iterator.o1().o6k_1;
        // Inline function 'kotlin.comparisons.maxOf' call
        var a = maxValue;
        maxValue = Math.max(a, v);
      }
      tmp$ret$13 = maxValue;
    }
    var tmp0_elvis_lhs = tmp$ret$13;
    var highest = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var list = SharedUtils_getInstance().r9s(element.f2(), highest + 1.0E-4);
    addAll(destination, list);
  }
  var ordered = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = get_session();
  var tmp_7 = await_0(this_3, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  var session = tmp_7;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.tho_1.jho_1;
  var tmp_8 = await_0(this_4, $completion);
  if (tmp_8 === get_COROUTINE_SUSPENDED())
    tmp_8 = yield tmp_8;
  var scopes = tmp_8;
  var tmp$ret$22;
  $l$block_0: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator_0 = scopes.m1();
    if (!iterator_0.n1()) {
      tmp$ret$22 = null;
      break $l$block_0;
    }
    var maxValue_0 = iterator_0.o1().o7z_1;
    while (iterator_0.n1()) {
      var v_0 = iterator_0.o1().o7z_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a_0 = maxValue_0;
      maxValue_0 = Math.max(a_0, v_0);
    }
    tmp$ret$22 = maxValue_0;
  }
  var tmp0_safe_receiver_1 = tmp$ret$22;
  var tmp1_elvis_lhs = tmp0_safe_receiver_1 == null ? null : tmp0_safe_receiver_1 + 1.0E-4;
  var highest_0 = tmp1_elvis_lhs == null ? 0.0 : tmp1_elvis_lhs;
  var tmp_9 = 1.0 - highest_0;
  var tmp0_0 = map.q3();
  var tmp$ret$26;
  $l$block_1: {
    // Inline function 'kotlin.collections.count' call
    var tmp_10;
    if (isInterface(tmp0_0, Collection())) {
      tmp_10 = tmp0_0.i1();
    } else {
      tmp_10 = false;
    }
    if (tmp_10) {
      tmp$ret$26 = 0;
      break $l$block_1;
    }
    var count = 0;
    var _iterator__ex2g4s_1 = tmp0_0.m1();
    while (_iterator__ex2g4s_1.n1()) {
      var element_1 = _iterator__ex2g4s_1.o1();
      if (!(element_1 == null)) {
        count = count + 1 | 0;
        checkCountOverflow(count);
      }
    }
    tmp$ret$26 = count;
  }
  var step = tmp_9 / (tmp$ret$26 + 1 | 0);
  // Inline function 'kotlin.collections.mapIndexed' call
  var this_5 = filterNotNull(map.q3());
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination_1 = ArrayList().u(collectionSizeOrDefault(this_5, 10));
  var index = 0;
  var _iterator__ex2g4s_2 = this_5.m1();
  while (_iterator__ex2g4s_2.n1()) {
    var item = _iterator__ex2g4s_2.o1();
    var _unary__edvuaz = index;
    index = _unary__edvuaz + 1 | 0;
    var idx = checkIndexOverflow(_unary__edvuaz);
    var tmp$ret$28 = item.u7z(VOID, VOID, VOID, VOID, highest_0 + (idx + 1 | 0) * step);
    destination_1.v(tmp$ret$28);
  }
  var orderedGroups = destination_1;
  // Inline function 'kotlin.collections.isNotEmpty' call
  if (!orderedGroups.i1()) {
    // Inline function 'kotlin.collections.partition' call
    var first = ArrayList().w();
    var second = ArrayList().w();
    var _iterator__ex2g4s_3 = orderedGroups.m1();
    while (_iterator__ex2g4s_3.n1()) {
      var element_2 = _iterator__ex2g4s_3.o1();
      if (element_2.q7z_1 == null) {
        first.v(element_2);
      } else {
        second.v(element_2);
      }
    }
    var _destruct__k2r9zo = new (Pair())(first, second);
    var top = _destruct__k2r9zo.cf();
    var inner = _destruct__k2r9zo.df();
    var tmp_11 = session.ufv_1.aeo(top, $completion);
    if (tmp_11 === get_COROUTINE_SUSPENDED())
      tmp_11 = yield tmp_11;
    var tmp_12 = session.ufv_1.aeo(inner, $completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
  }
  var tmp_13 = session.mfv_1.aeo(ordered, $completion);
  if (tmp_13 === get_COROUTINE_SUSPENDED())
    tmp_13 = yield tmp_13;
  // Inline function 'kotlin.collections.associateBy' call
  var this_6 = plus(scopes, orderedGroups);
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_6, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_2 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_4 = this_6.m1();
  while (_iterator__ex2g4s_4.n1()) {
    var element_3 = _iterator__ex2g4s_4.o1();
    var tmp$ret$34 = element_3.k7z_1;
    destination_2.s3(tmp$ret$34, element_3);
  }
  var allScopes = destination_2;
  // Inline function 'kotlin.collections.mapValues' call
  // Inline function 'kotlin.collections.mapValuesTo' call
  var destination_3 = LinkedHashMap().fc(mapCapacity(map.p1()));
  // Inline function 'kotlin.collections.associateByTo' call
  var _iterator__ex2g4s_5 = map.d2().m1();
  while (_iterator__ex2g4s_5.n1()) {
    var element_4 = _iterator__ex2g4s_5.o1();
    var tmp_14 = element_4.e2();
    // Inline function 'kotlin.collections.component2' call
    var items = element_4.f2();
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_4 = ArrayList().u(collectionSizeOrDefault(items, 10));
    var _iterator__ex2g4s_6 = items.m1();
    while (_iterator__ex2g4s_6.n1()) {
      var item_0 = _iterator__ex2g4s_6.o1();
      var tmp$ret$39 = item_0.g6k_1;
      destination_4.v(tmp$ret$39);
    }
    var ids = toSet(destination_4);
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination_5 = ArrayList().w();
    var _iterator__ex2g4s_7 = ordered.m1();
    while (_iterator__ex2g4s_7.n1()) {
      var element_5 = _iterator__ex2g4s_7.o1();
      if (ids.t1(element_5.g6k_1)) {
        destination_5.v(element_5);
      }
    }
    destination_3.s3(tmp_14, destination_5);
  }
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_6 = ArrayList().w();
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_8 = destination_3.d2().m1();
  while (_iterator__ex2g4s_8.n1()) {
    var element_6 = _iterator__ex2g4s_8.o1();
    // Inline function 'kotlin.collections.component1' call
    var view = element_6.e2();
    // Inline function 'kotlin.collections.component2' call
    var items_0 = element_6.f2();
    var set = view == null ? null : render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_6drns3(view, allScopes);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination_7 = ArrayList().u(collectionSizeOrDefault(items_0, 10));
    var _iterator__ex2g4s_9 = items_0.m1();
    while (_iterator__ex2g4s_9.n1()) {
      var item_1 = _iterator__ex2g4s_9.o1();
      // Inline function 'kotlin.apply' call
      var this_7 = $this.tho_1.nho(item_1);
      if (!(view == null)) {
        var tmp_15 = modify(this_7.chn_1, EditLineItems$render$slambda$slambda$slambda_0(view, set), $completion);
        if (tmp_15 === get_COROUTINE_SUSPENDED())
          tmp_15 = yield tmp_15;
      }
      destination_7.v(this_7);
    }
    var list_0 = destination_7;
    addAll(destination_6, list_0);
  }
  var newForms = destination_6;
  var tmp_16 = modify($this.tho_1.kho_1, EditLineItems$render$slambda$slambda$slambda_2($this.tho_1, newForms), $completion);
  if (tmp_16 === get_COROUTINE_SUSPENDED())
    tmp_16 = yield tmp_16;
  return Unit_instance;
}
var EditLineItems$render$slambda$slambda$slambdaClass;
function EditLineItems$render$slambda$slambda$slambda() {
  if (EditLineItems$render$slambda$slambda$slambdaClass === VOID) {
    class $ {
      constructor($view, $set) {
        this.who_1 = $view;
        this.xho_1 = $set;
      }
      bgy(it, $completion) {
        return it.i6l(VOID, VOID, VOID, this.who_1.k7z_1, this.xho_1);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$slambda$slambda$slambdaClass = $;
  }
  return EditLineItems$render$slambda$slambda$slambdaClass;
}
function EditLineItems$render$slambda$slambda$slambda_0($view, $set) {
  var i = new (EditLineItems$render$slambda$slambda$slambda())($view, $set);
  var l = (it, $completion) => i.bgy(it, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItems$render$slambda$slambda$slambdaClass_0;
function EditLineItems$render$slambda$slambda$slambda_1() {
  if (EditLineItems$render$slambda$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0, $newForms) {
        this.yho_1 = this$0;
        this.zho_1 = $newForms;
      }
      qho(it, $completion) {
        return sorted_0(this.yho_1, plus(it, this.zho_1), $completion);
      }
      s2(p1, $completion) {
        return this.qho((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$slambda$slambda$slambdaClass_0 = $;
  }
  return EditLineItems$render$slambda$slambda$slambdaClass_0;
}
function EditLineItems$render$slambda$slambda$slambda_2(this$0, $newForms) {
  var i = new (EditLineItems$render$slambda$slambda$slambda_1())(this$0, $newForms);
  var l = (it, $completion) => i.qho(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_5($this, $completion) {
  var tmp = get_dialogStack();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_notNullContractor();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0;
  tmp.xgd(new (NewTasksFromSpecsDialog())(tmp_1, $this.ahp_1.dho_1, EditLineItems$render$slambda$slambda_0($this.ahp_1)));
  return Unit_instance;
}
var EditLineItems$render$slambda$slambdaClass;
function EditLineItems$render$slambda$slambda() {
  if (EditLineItems$render$slambda$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.tho_1 = this$0;
      }
      bhp(map, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_4.bind(VOID, this, map), $completion);
      }
      s2(p1, $completion) {
        return this.bhp((!(p1 == null) ? isInterface(p1, KtMap()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$slambda$slambdaClass = $;
  }
  return EditLineItems$render$slambda$slambdaClass;
}
function EditLineItems$render$slambda$slambda_0(this$0) {
  var i = new (EditLineItems$render$slambda$slambda())(this$0);
  var l = (map, $completion) => i.bhp(map, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_6($this, d, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.chp_1.kho_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0 = tmp;
  var tmp$ret$1;
  $l$block: {
    // Inline function 'kotlin.collections.maxOfOrNull' call
    var iterator = tmp0.m1();
    if (!iterator.n1()) {
      tmp$ret$1 = null;
      break $l$block;
    }
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = iterator.o1().chn_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var maxValue = tmp_0.o6k_1;
    while (iterator.n1()) {
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_2 = iterator.o1().chn_1;
      var tmp_1 = await_0(this_2, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      var v = tmp_1.o6k_1;
      // Inline function 'kotlin.comparisons.maxOf' call
      var a = maxValue;
      maxValue = Math.max(a, v);
    }
    tmp$ret$1 = maxValue;
  }
  var tmp0_elvis_lhs = tmp$ret$1;
  return d.i6l(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, ((tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs) + 1.0) / 2);
}
function *_generator_invoke__zhh2q8_7($this, $completion) {
  var newForm = $this.dhp_1.nho(null);
  var tmp = modify(newForm.chn_1, EditLineItems$render$slambda$slambda_2($this.dhp_1), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = modify($this.dhp_1.kho_1, EditLineItems$render$slambda$slambda_4($this.dhp_1, newForm), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  newForm.khn_1.pg4(VOID, Align_Start_getInstance());
  newForm.lhn_1.mg5();
  return Unit_instance;
}
var EditLineItems$render$slambda$slambdaClass_0;
function EditLineItems$render$slambda$slambda_1() {
  if (EditLineItems$render$slambda$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.chp_1 = this$0;
      }
      bgy(d, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_6.bind(VOID, this, d), $completion);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$slambda$slambdaClass_0 = $;
  }
  return EditLineItems$render$slambda$slambdaClass_0;
}
function EditLineItems$render$slambda$slambda_2(this$0) {
  var i = new (EditLineItems$render$slambda$slambda_1())(this$0);
  var l = (d, $completion) => i.bgy(d, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItems$render$slambda$slambdaClass_1;
function EditLineItems$render$slambda$slambda_3() {
  if (EditLineItems$render$slambda$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0, $newForm) {
        this.ehp_1 = this$0;
        this.fhp_1 = $newForm;
      }
      qho(it, $completion) {
        return sorted_0(this.ehp_1, plus_0(it, this.fhp_1), $completion);
      }
      s2(p1, $completion) {
        return this.qho((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$slambda$slambdaClass_1 = $;
  }
  return EditLineItems$render$slambda$slambdaClass_1;
}
function EditLineItems$render$slambda$slambda_4(this$0, $newForm) {
  var i = new (EditLineItems$render$slambda$slambda_3())(this$0, $newForm);
  var l = (it, $completion) => i.qho(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_8($this, it, $completion) {
  var tmp = reorderForms($this.ghp_1, it, null, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_9($this, scope, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.hhp_1.kho_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected.t1(element.ahn_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_0 = modify(element_0.chn_1, EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1_0(scope), $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1Class;
function EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1() {
  if (EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1Class === VOID) {
    class $ {
      constructor($scope) {
        this.ihp_1 = $scope;
      }
      bgy(it, $completion) {
        return it.i6l(VOID, VOID, VOID, this.ihp_1.k7z_1, this.ihp_1.p7z_1 ? this.ihp_1.k7z_1 : null);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1Class = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1Class;
}
function EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1_0($scope) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda$slambda_5uydg1())($scope);
  var l = (it, $completion) => i.bgy(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_10($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.jhp_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = get_session();
  var tmp_1 = await_0(this_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$1 = tmp_1;
  var tmp_2 = reorder(it, tmp_0, tmp$ret$1.ufv_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_11($this, draft, selected, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var session = tmp;
  var tmp_0 = modify(draft, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_0($this.lhp_1), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = pushChanges(draft, session.ufv_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var scope = tmp_1;
  var tmp_2 = session.tfw().vfg_1.zfq(scope.k7z_1, selected, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var selected_0 = toSet(selected);
  var tmp_3 = (it) => selected_0.t1(it.g6k_1);
  session.mfv_1.ceo(tmp_3, (it) => it.i6l(VOID, VOID, VOID, scope.k7z_1));
  var tmp_4 = render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_8ypbvc(scope, $this.khp_1, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var scopeSet = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.khp_1.kho_1;
  var tmp_5 = await_0(this_1, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp_5;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (selected_0.t1(element.ahn_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp_6 = modify(element_0.chn_1, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_2(scope, scopeSet), $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
  }
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass === VOID) {
    class $ {
      constructor($scope) {
        this.mhp_1 = $scope;
      }
      nhp(it, $completion) {
        return it.e80(VOID, VOID, VOID, this.mhp_1.k7z_1);
      }
      s2(p1, $completion) {
        return this.nhp(p1 instanceof ScopeView() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_0($scope) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj())($scope);
  var l = (it, $completion) => i.nhp(it, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_0;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_1() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_0 === VOID) {
    class $ {
      constructor($scope, $scopeSet) {
        this.ohp_1 = $scope;
        this.php_1 = $scopeSet;
      }
      bgy(it, $completion) {
        return it.i6l(VOID, VOID, VOID, this.ohp_1.k7z_1, this.php_1);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_0 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_0;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_2($scope, $scopeSet) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_1())($scope, $scopeSet);
  var l = (it, $completion) => i.bgy(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_12($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.qhp_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var scope = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.rhp_1.kho_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = element.chn_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var line = tmp_1;
    var tmp_2;
    // Inline function 'kotlin.let' call
    var it = line.j6k_1;
    if (it == null || equals(it, scope.k7z_1)) {
      tmp_2 = AdjustedLineItem().ify(line);
    } else {
      tmp_2 = null;
    }
    var tmp0_safe_receiver = tmp_2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var options = destination;
  var tmp_3 = get_dialogStack();
  var tmp_4 = new (Subscope())(scope);
  tmp_3.xgd(new (CreateScopeViewDialog())(options, tmp_4, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_0($this.rhp_1, scope)));
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass === VOID) {
    class $ {
      constructor($this$0, $scope) {
        this.khp_1 = $this$0;
        this.lhp_1 = $scope;
      }
      shp(draft, selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_11.bind(VOID, this, draft, selected), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = (!(p1 == null) ? isInterface(p1, Draft()) : false) ? p1 : THROW_CCE();
        return this.shp(tmp, (!(p2 == null) ? isInterface(p2, KtList()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_0($this$0, $scope) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v())($this$0, $scope);
  var l = (draft, selected, $completion) => i.shp(draft, selected, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_13($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.thp_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var mainSpecGroup = tmp.i99();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.uhp_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.associate' call
  var this_2 = tmp_0;
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_2, 10)), 16);
  // Inline function 'kotlin.collections.associateTo' call
  var destination = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s = this_2.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'kotlin.collections.plusAssign' call
    var pair = to(element.k7z_1, element.h99(mainSpecGroup.o82_1));
    destination.s3(pair.af_1, pair.bf_1);
  }
  var tmp_1 = destination;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.thp_1;
  var tmp_2 = await_0(this_3, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp$ret$6 = tmp_2;
  var allSpecGroups = plus_1(tmp_1, to(tmp$ret$6.k7z_1, mainSpecGroup));
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.vhp_1;
  var tmp_3 = await_0(this_4, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.collections.map' call
  var this_5 = tmp_3;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_0 = this_5.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_6 = get_notNullContractor();
    var tmp_4 = await_0(this_6, $completion);
    if (tmp_4 === get_COROUTINE_SUSPENDED())
      tmp_4 = yield tmp_4;
    var tmp_5 = tmp_4;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_7 = item.dhn_1;
    var tmp_6 = await_0(this_7, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    // Inline function 'kotlin.collections.get' call
    var key = tmp_6;
    var tmp_7 = (isInterface(allSpecGroups, KtMap()) ? allSpecGroups : THROW_CCE()).p3(key);
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_8 = item.hhn_1.lg8_1;
    var tmp_8 = await_0(this_8, $completion);
    if (tmp_8 === get_COROUTINE_SUSPENDED())
      tmp_8 = yield tmp_8;
    var tmp_9 = tmp_8;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_9 = item.hhn_1.mg8_1;
    var tmp_10 = await_0(this_9, $completion);
    if (tmp_10 === get_COROUTINE_SUSPENDED())
      tmp_10 = yield tmp_10;
    var tmp_11 = tmp_10;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_10 = item.hhn_1.og8_1;
    var tmp_12 = await_0(this_10, $completion);
    if (tmp_12 === get_COROUTINE_SUSPENDED())
      tmp_12 = yield tmp_12;
    var tmp_13 = tmp_12.a5s_1;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_11 = item.hhn_1.kg8_1;
    var tmp_14 = await_0(this_11, $completion);
    if (tmp_14 === get_COROUTINE_SUSPENDED())
      tmp_14 = yield tmp_14;
    var tmp_15 = tmp_14;
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_12 = item.hhn_1.eg8_1;
    var tmp_16 = await_0(this_12, $completion);
    if (tmp_16 === get_COROUTINE_SUSPENDED())
      tmp_16 = yield tmp_16;
    var tmp$ret$15 = tmp_16;
    var tmp_17 = resolveProjectAttachments(tmp$ret$15, $completion);
    if (tmp_17 === get_COROUTINE_SUSPENDED())
      tmp_17 = yield tmp_17;
    var tmp$ret$16 = new (Specification())(VOID, tmp_5, tmp_7, tmp_9, tmp_11, tmp_13, tmp_15, tmp_17);
    destination_0.v(tmp$ret$16);
  }
  var newSpecs = destination_0;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_13 = get_session();
  var tmp_18 = await_0(this_13, $completion);
  if (tmp_18 === get_COROUTINE_SUSPENDED())
    tmp_18 = yield tmp_18;
  var tmp_19 = tmp_18.ofv_1.aeo(newSpecs, $completion);
  if (tmp_19 === get_COROUTINE_SUSPENDED())
    tmp_19 = yield tmp_19;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_14($this, $completion) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder().d1();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.xhp_1;
  var tmp = await_0(this_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var subCount = tmp.p1();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = $this.yhp_1;
  var tmp_0 = await_0(this_2, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var itemCount = tmp_0.p1();
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_3 = $this.zhp_1;
  var tmp_1 = await_0(this_3, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp$ret$2 = tmp_1;
  this_0.wb('Create a spec group from "' + tmp$ret$2.m7z_1 + '"');
  if (subCount > 0) {
    this_0.wb(' with ' + subCount + ' sub-group' + (!(subCount === 1) ? 's' : ''));
  }
  this_0.wb(', adding ' + itemCount + ' work item' + (!(itemCount === 1) ? 's' : '') + ' as specifications.');
  var tmp_2 = this_0.toString();
  confirmationDialog($this.whp_1, 'Add Spec Group', tmp_2, 'Create', VOID, VOID, VOID, VOID, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_2($this.zhp_1, $this.xhp_1, $this.yhp_1));
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_0;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_1() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_0 === VOID) {
    class $ {
      constructor($scope, $subscopes, $allItems) {
        this.thp_1 = $scope;
        this.uhp_1 = $subscopes;
        this.vhp_1 = $allItems;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_13.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_0 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_0;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_2($scope, $subscopes, $allItems) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_1())($scope, $subscopes, $allItems);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_15($this, scope, selection, $completion) {
  var selection_0 = toSet(selection);
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = $this.ahq_1;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    if (equals(element.nfy(), scope.k7z_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(destination, 10));
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item = _iterator__ex2g4s_0.o1();
    var tmp$ret$3 = item.kf9_1;
    destination_0.v(tmp$ret$3);
  }
  var affected = plus_2(selection_0, destination_0);
  var tmp = render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_8ypbvc(scope, $this.bhq_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var scopeSet = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bhq_1.kho_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.filter' call
  var tmp0_0 = tmp_0;
  // Inline function 'kotlin.collections.filterTo' call
  var destination_1 = ArrayList().w();
  var _iterator__ex2g4s_1 = tmp0_0.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var element_0 = _iterator__ex2g4s_1.o1();
    if (affected.t1(element_0.ahn_1)) {
      destination_1.v(element_0);
    }
  }
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_2 = destination_1.m1();
  while (_iterator__ex2g4s_2.n1()) {
    var element_1 = _iterator__ex2g4s_2.o1();
    var tmp_1 = modify(element_1.chn_1, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_4(selection_0, scope, scopeSet), $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
  }
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_1;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_3() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_1 === VOID) {
    class $ {
      constructor($selection, $scope, $scopeSet) {
        this.chq_1 = $selection;
        this.dhq_1 = $scope;
        this.ehq_1 = $scopeSet;
      }
      bgy(it, $completion) {
        var inScope = this.chq_1.t1(it.g6k_1);
        return it.i6l(VOID, VOID, VOID, inScope ? this.dhq_1.k7z_1 : this.dhq_1.q7z_1, inScope || this.ehq_1 == null || !equals(this.ehq_1, this.dhq_1.k7z_1) ? this.ehq_1 : null);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_1 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_1;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_4($selection, $scope, $scopeSet) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_3())($selection, $scope, $scopeSet);
  var l = (it, $completion) => i.bgy(it, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_16($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.fhq_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var scope = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_1 = $this.ghq_1.kho_1;
  var tmp_0 = await_0(this_1, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = tmp_0;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_2 = element.chn_1;
    var tmp_1 = await_0(this_2, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    var line = tmp_1;
    var tmp_2;
    // Inline function 'kotlin.let' call
    var it = line.j6k_1;
    if (it == null || equals(it, scope.k7z_1) || equals(it, scope.q7z_1)) {
      tmp_2 = AdjustedLineItem().ify(line);
    } else {
      tmp_2 = null;
    }
    var tmp0_safe_receiver = tmp_2;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var options = destination;
  var tmp_3 = get_dialogStack();
  var tmp0_safe_receiver_0 = scope.q7z_1;
  var tmp_4;
  if (tmp0_safe_receiver_0 == null) {
    tmp_4 = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = $this.ghq_1.jho_1;
    var tmp_5 = await_0(this_3, $completion);
    if (tmp_5 === get_COROUTINE_SUSPENDED())
      tmp_5 = yield tmp_5;
    // Inline function 'kotlin.collections.find' call
    var tmp0_0 = tmp_5;
    var tmp$ret$14;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var _iterator__ex2g4s_0 = tmp0_0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element_0 = _iterator__ex2g4s_0.o1();
        if (element_0.k7z_1.equals(tmp0_safe_receiver_0)) {
          tmp$ret$14 = element_0;
          break $l$block;
        }
      }
      tmp$ret$14 = null;
    }
    tmp_4 = tmp$ret$14;
  }
  var tmp_6 = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.hhq_1;
  var tmp_7 = await_0(this_4, $completion);
  if (tmp_7 === get_COROUTINE_SUSPENDED())
    tmp_7 = yield tmp_7;
  // Inline function 'kotlin.collections.map' call
  var this_5 = tmp_7;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(this_5, 10));
  var _iterator__ex2g4s_1 = this_5.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item = _iterator__ex2g4s_1.o1();
    var tmp$ret$19 = item.ahn_1;
    destination_0.v(tmp$ret$19);
  }
  var tmp_8 = toSet(destination_0);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_6 = $this.ihq_1;
  var tmp_9 = await_0(this_6, $completion);
  if (tmp_9 === get_COROUTINE_SUSPENDED())
    tmp_9 = yield tmp_9;
  // Inline function 'kotlin.collections.map' call
  var this_7 = tmp_9;
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().u(collectionSizeOrDefault(this_7, 10));
  var _iterator__ex2g4s_2 = this_7.m1();
  while (_iterator__ex2g4s_2.n1()) {
    var item_0 = _iterator__ex2g4s_2.o1();
    var tmp$ret$23 = item_0.ahn_1;
    destination_1.v(tmp$ret$23);
  }
  // Inline function 'kotlin.collections.isNotEmpty' call
  var tmp_10 = !minus(tmp_8, toSet(destination_1)).i1();
  tmp_3.xgd(new (EditScopeViewDialog())(options, scope, tmp_6, tmp_10, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_4(options, $this.ghq_1)));
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_1;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_3() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_1 === VOID) {
    class $ {
      constructor($options, $this$0) {
        this.ahq_1 = $options;
        this.bhq_1 = $this$0;
      }
      jhq(scope, selection, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_15.bind(VOID, this, scope, selection), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ScopeView() ? p1 : THROW_CCE();
        return this.jhq(tmp, (!(p2 == null) ? isInterface(p2, KtList()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_1 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_1;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_4($options, $this$0) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_3())($options, $this$0);
  var l = (scope, selection, $completion) => i.jhq(scope, selection, $completion);
  l.$arity = 2;
  return l;
}
function *_generator_invoke__zhh2q8_17($this, confirmed, $completion) {
  if (!confirmed)
    return Unit_instance;
  var tmp = setOf($this.khq_1.k7z_1);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lhq_1;
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  // Inline function 'kotlin.collections.map' call
  var this_1 = tmp_0;
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(this_1, 10));
  var _iterator__ex2g4s = this_1.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp$ret$1 = item.k7z_1;
    destination.v(tmp$ret$1);
  }
  var ids = plus_2(tmp, destination);
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_2 = get_session();
  var tmp_1 = await_0(this_2, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_1.ufv_1.kft($this.khq_1.k7z_1).iem($completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_8ypbvc($this.khq_1, $this.mhq_1, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  // Inline function 'kotlin.takeIf' call
  var this_3 = tmp_3;
  var tmp_4;
  if (!equals(this_3, $this.khq_1.k7z_1)) {
    tmp_4 = this_3;
  } else {
    tmp_4 = null;
  }
  var set = tmp_4;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_4 = $this.mhq_1.kho_1;
  var tmp_5 = await_0(this_4, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s_0 = tmp_5.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element = _iterator__ex2g4s_0.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_5 = element.chn_1;
    var tmp_6 = await_0(this_5, $completion);
    if (tmp_6 === get_COROUTINE_SUSPENDED())
      tmp_6 = yield tmp_6;
    var draft = tmp_6;
    if (contains(ids, draft.j6k_1)) {
      var tmp_7 = modify(element.chn_1, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_6($this.khq_1, set), $completion);
      if (tmp_7 === get_COROUTINE_SUSPENDED())
        tmp_7 = yield tmp_7;
    }
  }
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_2;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_5() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_2 === VOID) {
    class $ {
      constructor($scope, $set) {
        this.nhq_1 = $scope;
        this.ohq_1 = $set;
      }
      bgy(item, $completion) {
        return item.i6l(VOID, VOID, VOID, this.nhq_1.q7z_1, this.ohq_1);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_2 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhjClass_2;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_6($scope, $set) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda$slambda_7v4qhj_5())($scope, $set);
  var l = (item, $completion) => i.bgy(item, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_18($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.phq_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var scope = tmp;
  var tmp_0 = get_dialogStack();
  var tmp_1 = 'Delete ' + scope.m7z_1 + '?';
  var tmp_2 = DeleteButtonSemantic_getInstance();
  tmp_0.xgd(new (GenericConfirmationDialog())(tmp_1, 'This cannot be undone.', VOID, 'Delete', VOID, tmp_2, VOID, VOID, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_6(scope, $this.qhq_1, $this.rhq_1)));
  return Unit_instance;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_2;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_5() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_2 === VOID) {
    class $ {
      constructor($scope, $subscopes, $this$0) {
        this.khq_1 = $scope;
        this.lhq_1 = $subscopes;
        this.mhq_1 = $this$0;
      }
      cgk(confirmed, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_17.bind(VOID, this, confirmed), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_2 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5vClass_2;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_6($scope, $subscopes, $this$0) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda$slambda_s14c5v_5())($scope, $subscopes, $this$0);
  var l = (confirmed, $completion) => i.cgk(confirmed, $completion);
  l.$arity = 1;
  return l;
}
function *_generator_invoke__zhh2q8_19($this, it, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.thq_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = reorderForms($this.shq_1, it, tmp$ret$0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_sorted__ueyqhh($this, _this__u8e3s4, $completion) {
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList().u(collectionSizeOrDefault(_this__u8e3s4, 10));
  var _iterator__ex2g4s = _this__u8e3s4.m1();
  while (_iterator__ex2g4s.n1()) {
    var item = _iterator__ex2g4s.o1();
    var tmp = awaitOnce(item.chn_1, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tmp$ret$0 = to(item, tmp.o6k_1);
    destination.v(tmp$ret$0);
  }
  // Inline function 'kotlin.collections.sortedBy' call
  // Inline function 'kotlin.comparisons.compareBy' call
  var tmp_0 = EditLineItems$sorted$lambda;
  var tmp$ret$3 = new (sam$kotlin_Comparator$0())(tmp_0);
  // Inline function 'kotlin.collections.map' call
  var this_0 = sortedWith(destination, tmp$ret$3);
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList().u(collectionSizeOrDefault(this_0, 10));
  var _iterator__ex2g4s_0 = this_0.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var item_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$5 = item_0.af_1;
    destination_0.v(tmp$ret$5);
  }
  return destination_0;
}
function sorted_0($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sorted__ueyqhh.bind(VOID, $this, _this__u8e3s4), $completion);
}
function *_generator_sort__qhqj86($this, _this__u8e3s4, $completion) {
  var tmp = modify(_this__u8e3s4, EditLineItems$sort$slambda_0($this), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function sort($this, _this__u8e3s4, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_sort__qhqj86.bind(VOID, $this, _this__u8e3s4), $completion);
}
function *_generator_reorderForms__x9h3mc($this, _this__u8e3s4, view, $completion) {
  if (_this__u8e3s4.cdl_1 === _this__u8e3s4.ddl_1)
    return Unit_instance;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.kho_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.filter' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.filterTo' call
  var destination = ArrayList().w();
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = element.chn_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var tmp_1 = tmp_0.j6k_1;
    if (equals(tmp_1, view == null ? null : view.k7z_1)) {
      destination.v(element);
    }
  }
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(destination, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination_0 = LinkedHashMap().fc(capacity);
  var _iterator__ex2g4s_0 = destination.m1();
  while (_iterator__ex2g4s_0.n1()) {
    var element_0 = _iterator__ex2g4s_0.o1();
    var tmp$ret$5 = element_0.ahn_1;
    destination_0.s3(tmp$ret$5, element_0);
  }
  var fms = destination_0;
  if (fms.p1() <= 1)
    return Unit_instance;
  // Inline function 'kotlin.collections.map' call
  var this_2 = fms.r3();
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList().u(collectionSizeOrDefault(this_2, 10));
  var _iterator__ex2g4s_1 = this_2.m1();
  while (_iterator__ex2g4s_1.n1()) {
    var item = _iterator__ex2g4s_1.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_3 = item.chn_1;
    var tmp_2 = await_0(this_3, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    var tmp$ret$9 = tmp_2;
    destination_1.v(tmp$ret$9);
  }
  var tmp2 = _this__u8e3s4.cdl_1;
  // Inline function 'com.crowpay.createReorderMods' call
  var toIdx = _this__u8e3s4.ddl_1;
  // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
  var tmp_3 = serializerOrContextual(createKType(getKClass(LineItem()), arrayOf([]), false));
  var tmp$ret$12 = isInterface(tmp_3, KSerializer()) ? tmp_3 : THROW_CCE();
  var orderMods = createReorderMods(destination_1, tmp$ret$12, tmp2, toIdx);
  // Inline function 'kotlin.collections.iterator' call
  var _iterator__ex2g4s_2 = orderMods.d2().m1();
  while (_iterator__ex2g4s_2.n1()) {
    var _destruct__k2r9zo = _iterator__ex2g4s_2.o1();
    // Inline function 'kotlin.collections.component1' call
    var id = _destruct__k2r9zo.e2();
    // Inline function 'kotlin.collections.component2' call
    var mod = _destruct__k2r9zo.f2();
    var tmp0_safe_receiver = fms.p3(id);
    var tmp1_safe_receiver = tmp0_safe_receiver == null ? null : tmp0_safe_receiver.chn_1;
    if (tmp1_safe_receiver == null)
      null;
    else {
      var tmp_4 = modify(tmp1_safe_receiver, EditLineItems$reorderForms$slambda_0(mod), $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
    }
  }
  var tmp_5 = sort($this, $this.kho_1, $completion);
  if (tmp_5 === get_COROUTINE_SUSPENDED())
    tmp_5 = yield tmp_5;
  return Unit_instance;
}
function reorderForms($this, _this__u8e3s4, view, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_reorderForms__x9h3mc.bind(VOID, $this, _this__u8e3s4, view), $completion);
}
function *_generator_hasUnsavedChanges__b8k745($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.lho_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return !tmp;
}
function *_generator_hasNoLineItems__a80iix($this, $completion) {
  var tmp = awaitOnce($this.kho_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.i1();
}
var sam$kotlin_Comparator$0Class;
function sam$kotlin_Comparator$0() {
  if (sam$kotlin_Comparator$0Class === VOID) {
    class $ {
      constructor(function_0) {
        this.uhq_1 = function_0;
      }
      wi(a, b) {
        return this.uhq_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.uhq_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class = $;
  }
  return sam$kotlin_Comparator$0Class;
}
var sam$kotlin_Comparator$0Class_0;
function sam$kotlin_Comparator$0_0() {
  if (sam$kotlin_Comparator$0Class_0 === VOID) {
    class $ {
      constructor(function_0) {
        this.vhq_1 = function_0;
      }
      wi(a, b) {
        return this.vhq_1(a, b);
      }
      compare(a, b) {
        return this.wi(a, b);
      }
      i4() {
        return this.vhq_1;
      }
      equals(other) {
        var tmp;
        if (!(other == null) ? isInterface(other, Comparator()) : false) {
          var tmp_0;
          if (!(other == null) ? isInterface(other, FunctionAdapter()) : false) {
            tmp_0 = equals(this.i4(), other.i4());
          } else {
            tmp_0 = false;
          }
          tmp = tmp_0;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return hashCode(this.i4());
      }
    }
    initMetadataForClass($, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator(), FunctionAdapter()]);
    sam$kotlin_Comparator$0Class_0 = $;
  }
  return sam$kotlin_Comparator$0Class_0;
}
function *_generator_render$_anonymous_$_anonymous_$createScopeView__zgazdz(this$0, scopeSet, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = this$0.kho_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  // Inline function 'kotlin.collections.mapNotNull' call
  var tmp0 = tmp;
  // Inline function 'kotlin.collections.mapNotNullTo' call
  var destination = ArrayList().w();
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = tmp0.m1();
  while (_iterator__ex2g4s.n1()) {
    var element = _iterator__ex2g4s.o1();
    // Inline function 'com.lightningkite.reactive.context.invoke' call
    var this_1 = element.chn_1;
    var tmp_0 = await_0(this_1, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    var line = tmp_0;
    var tmp0_safe_receiver = line.j6k_1 == null ? AdjustedLineItem().ify(line) : null;
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      destination.v(tmp0_safe_receiver);
    }
  }
  var tmp_1 = destination;
  return NewScopeViewDialog(tmp_1, scopeSet, EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyh_0(this$0));
}
function render$_anonymous_$_anonymous_$createScopeView_9n5ywx(this$0, scopeSet, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_render$_anonymous_$_anonymous_$createScopeView__zgazdz.bind(VOID, this$0, scopeSet), $completion);
}
function render$_anonymous_$_anonymous_$expandIfNarrow_h26h72(_this__u8e3s4) {
  return get_viewIsNarrow(_this__u8e3s4) ? get_expanding(_this__u8e3s4) : Companion_getInstance_0();
}
function render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_6drns3(_this__u8e3s4, allScopes) {
  var tmp;
  if (_this__u8e3s4.p7z_1) {
    tmp = _this__u8e3s4.k7z_1;
  } else {
    // Inline function 'kotlin.collections.get' call
    var key = _this__u8e3s4.q7z_1;
    var tmp0_safe_receiver = (isInterface(allScopes, KtMap()) ? allScopes : THROW_CCE()).p3(key);
    tmp = tmp0_safe_receiver == null ? null : render$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_6drns3(tmp0_safe_receiver, allScopes);
  }
  return tmp;
}
function render$_anonymous_$_anonymous_$renderGroups_5lnnq(_this__u8e3s4, this$0, groups, reorderId, allowCreateNested) {
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.xbm(true);
  view.zb8(times(view.kba().hb0_1, 1.2));
  var tmp = EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejq_0(groups);
  forEachMaybeReorderable(view, groups, reorderId, tmp, VOID, VOID, ($this$forEachMaybeReorderable, scope, dragData) => {
    var groupId = lens(scope, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$lambda_i1hp8);
    var subscopes = remember(VOID, VOID, VOID, ($this$remember) => {
      var id = $this$remember.baj(groupId);
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(this$0.jho_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (equals(element.q7z_1, id)) {
          destination.v(element);
        }
      }
      return destination;
    });
    var allItems = remember(VOID, VOID, VOID, ($this$remember) => {
      var tmp = setOf($this$remember.baj(groupId));
      // Inline function 'kotlin.collections.map' call
      var this_0 = $this$remember.baj(subscopes);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList().u(collectionSizeOrDefault(this_0, 10));
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var item = _iterator__ex2g4s.o1();
        var tmp$ret$3 = item.k7z_1;
        destination.v(tmp$ret$3);
      }
      var ids = plus_2(tmp, destination);
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(this$0.kho_1);
      // Inline function 'kotlin.collections.filterTo' call
      var destination_0 = ArrayList().w();
      var _iterator__ex2g4s_0 = tmp0.m1();
      while (_iterator__ex2g4s_0.n1()) {
        var element = _iterator__ex2g4s_0.o1();
        if (contains(ids, $this$remember.baj(element.dhn_1))) {
          destination_0.v(element);
        }
      }
      return destination_0;
    });
    var topLevelItems = remember(VOID, VOID, VOID, ($this$remember) => {
      var id = $this$remember.baj(groupId);
      // Inline function 'kotlin.collections.filter' call
      var tmp0 = $this$remember.baj(allItems);
      // Inline function 'kotlin.collections.filterTo' call
      var destination = ArrayList().w();
      var _iterator__ex2g4s = tmp0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        if (equals($this$remember.baj(element.dhn_1), id)) {
          destination.v(element);
        }
      }
      return destination;
    });
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view = new (RowOrCol())($this$forEachMaybeReorderable.pc());
    var tmp0_elvis_lhs = $this$forEachMaybeReorderable.cbb_1;
    var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderable : tmp0_elvis_lhs;
    $this$forEachMaybeReorderable.ebb(p, view);
    view.xbm(true);
    var tmp = get_lightSection(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.row' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_0 = new (RowOrCol())(view.pc());
    var tmp0_elvis_lhs_0 = view.cbb_1;
    var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
    view.ebb(p_0, view_0);
    view_0.xbm(false);
    var $this$row = view_0;
    if (!(dragData == null)) {
      var tmp_0 = get_centered($this$row);
      // Inline function 'com.lightningkite.kiteui.views.direct.icon' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_1 = new (IconView())($this$row.pc());
      var tmp0_elvis_lhs_1 = $this$row.cbb_1;
      var p_1 = tmp0_elvis_lhs_1 == null ? $this$row : tmp0_elvis_lhs_1;
      $this$row.ebb(p_1, view_1);
      view_1.qbt(get_dragHandle(Companion_getInstance()));
      view_1.ebu('drag');
      var tmp_1 = KMutableProperty0();
      var tmp_2 = IconView$_get_dragData_$ref_4jg2ny(view_1);
      // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
      var this_0 = getPropertyCallableRef('dragData', 0, tmp_1, tmp_2, IconView$_set_dragData_$ref_k36t82(view_1));
      reactiveScope(view_1, ($this$reactiveScope) => {
        var tmp$ret$12 = $this$reactiveScope.baj(dragData).fcy(VOID, VOID, new (DragShadow())($this$row, Align_Start_getInstance(), VOID, get_rem(1)));
        this_0.set(tmp$ret$12);
        return Unit_instance;
      });
      $this$row.fbb(p_1, view_1);
      $this$row.jbb(tmp_0, view_1);
    }
    $this$row.jbb($this$row.ibb(shownWhen($this$row, VOID, ($this$shownWhen) => $this$shownWhen.baj(scope).p7z_1), get_centered($this$row)), scopeSetIcon($this$row, get_rem(1)));
    var tmp_3 = get_centered($this$row);
    // Inline function 'com.crowpay.views.theming.bodyBold' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_2 = new (TextView())($this$row.pc());
    var tmp0_elvis_lhs_2 = $this$row.cbb_1;
    var p_2 = tmp0_elvis_lhs_2 == null ? $this$row : tmp0_elvis_lhs_2;
    $this$row.ebb(p_2, view_2);
    view_2.jba(view_2.ob6_1.ybe(BodySemantic_getInstance().ybe(BoldSemantic_getInstance())));
    var tmp_4 = KMutableProperty0();
    var tmp_5 = TextView$_get_content_$ref_4pzcwl(view_2);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_1 = getPropertyCallableRef('content', 0, tmp_4, tmp_5, TextView$_set_content_$ref_pketfb(view_2));
    reactiveScope(view_2, ($this$reactiveScope) => {
      var tmp$ret$17 = $this$reactiveScope.baj(scope).m7z_1;
      this_1.set(tmp$ret$17);
      return Unit_instance;
    });
    $this$row.fbb(p_2, view_2);
    $this$row.jbb(tmp_3, view_2);
    var tmp_6 = $this$row.ibb(get_expanding($this$row), get_centered($this$row));
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_3 = new (TextView())($this$row.pc());
    var tmp0_elvis_lhs_3 = $this$row.cbb_1;
    var p_3 = tmp0_elvis_lhs_3 == null ? $this$row : tmp0_elvis_lhs_3;
    $this$row.ebb(p_3, view_3);
    view_3.jba(view_3.ob6_1.ybe(BodySemantic_getInstance()));
    view_3.bbs(Align_End_getInstance());
    var tmp_7 = KMutableProperty0();
    var tmp_8 = TextView$_get_content_$ref_4pzcwl_0(view_3);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_2 = getPropertyCallableRef('content', 0, tmp_7, tmp_8, TextView$_set_content_$ref_pketfb_0(view_3));
    reactiveScope(view_3, ($this$reactiveScope) => {
      // Inline function 'com.crowpay.extensions.sumMoney' call
      var this_0 = $this$reactiveScope.baj(allItems);
      var sum = Companion_instance.p91(0n);
      var _iterator__ex2g4s = this_0.m1();
      while (_iterator__ex2g4s.n1()) {
        var element = _iterator__ex2g4s.o1();
        var tmp = sum;
        var tmp$ret$24 = $this$reactiveScope.baj(element.chn_1).f6l_1;
        sum = MonetaryValue__plus_impl_c1ylt(tmp, tmp$ret$24);
      }
      var tmp$ret$25 = sum;
      var tmp$ret$26 = MonetaryValue__toString_impl_xslc77(tmp$ret$25);
      this_2.set(tmp$ret$26);
      return Unit_instance;
    });
    $this$row.fbb(p_3, view_3);
    $this$row.jbb(tmp_6, view_3);
    if (allowCreateNested) {
      var tmp_9 = get_textButton($this$row);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_4 = new (Button())($this$row.pc());
      var tmp0_elvis_lhs_4 = $this$row.cbb_1;
      var p_4 = tmp0_elvis_lhs_4 == null ? $this$row : tmp0_elvis_lhs_4;
      $this$row.ebb(p_4, view_4);
      view_4.eba(get_dp(2));
      body(view_4, '+ Group');
      onClick(view_4, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_0(scope, this$0));
      $this$row.fbb(p_4, view_4);
      $this$row.jbb(tmp_9, view_4);
    }
    if (allowCreateNested) {
      var tmp_10 = get_textButton($this$row);
      // Inline function 'com.lightningkite.kiteui.views.direct.button' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_5 = new (Button())($this$row.pc());
      var tmp0_elvis_lhs_5 = $this$row.cbb_1;
      var p_5 = tmp0_elvis_lhs_5 == null ? $this$row : tmp0_elvis_lhs_5;
      $this$row.ebb(p_5, view_5);
      view_5.eba(get_dp(2));
      // Inline function 'com.lightningkite.kiteui.views.direct.row' call
      // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
      var view_6 = new (RowOrCol())(view_5.pc());
      var tmp0_elvis_lhs_6 = view_5.cbb_1;
      var p_6 = tmp0_elvis_lhs_6 == null ? view_5 : tmp0_elvis_lhs_6;
      view_5.ebb(p_6, view_6);
      view_6.xbm(false);
      view_6.zb8(get_dp(2));
      view_6.jbb(get_centered(view_6), icon(view_6, resize(get_exportFile(Companion_getInstance()), get_rem(1)), 'Add Spec Group'));
      view_6.jbb(get_centered(view_6), body(view_6, 'Spec'));
      view_5.fbb(p_6, view_6);
      onClick(view_5, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_2(view_5, subscopes, allItems, scope));
      $this$row.fbb(p_5, view_5);
      $this$row.jbb(tmp_10, view_5);
    }
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_7 = new (Button())($this$row.pc());
    var tmp0_elvis_lhs_7 = $this$row.cbb_1;
    var p_7 = tmp0_elvis_lhs_7 == null ? $this$row : tmp0_elvis_lhs_7;
    $this$row.ebb(p_7, view_7);
    view_7.eba(get_dp(2));
    icon(view_7, resize(get_edit(Companion_getInstance()), get_rem_0(1.2)), 'Edit Scope');
    onClick(view_7, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_4(scope, this$0, allItems, topLevelItems));
    $this$row.fbb(p_7, view_7);
    // Inline function 'com.lightningkite.kiteui.views.direct.button' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_8 = new (Button())($this$row.pc());
    var tmp0_elvis_lhs_8 = $this$row.cbb_1;
    var p_8 = tmp0_elvis_lhs_8 == null ? $this$row : tmp0_elvis_lhs_8;
    $this$row.ebb(p_8, view_8);
    view_8.eba(get_dp(2));
    icon(view_8, resize(get_trash(Companion_getInstance()), get_rem_0(1.2)), 'Delete Scope');
    onClick(view_8, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_6(scope, subscopes, this$0));
    $this$row.fbb(p_8, view_8);
    view.fbb(p_0, view_0);
    view.jbb(tmp, view_0);
    var tmp_11 = shownWhen(view, VOID, ($this$shownWhen) => {
      // Inline function 'kotlin.text.isNullOrBlank' call
      var this_0 = $this$shownWhen.baj(scope).n7z_1;
      return !(this_0 == null || isBlank(this_0));
    });
    // Inline function 'com.crowpay.views.theming.body' call
    // Inline function 'com.lightningkite.kiteui.views.direct.text' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_9 = new (TextView())(view.pc());
    var tmp0_elvis_lhs_9 = view.cbb_1;
    var p_9 = tmp0_elvis_lhs_9 == null ? view : tmp0_elvis_lhs_9;
    view.ebb(p_9, view_9);
    view_9.jba(view_9.ob6_1.ybe(BodySemantic_getInstance()));
    var tmp_12 = KMutableProperty0();
    var tmp_13 = TextView$_get_content_$ref_4pzcwl_1(view_9);
    // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
    var this_3 = getPropertyCallableRef('content', 0, tmp_12, tmp_13, TextView$_set_content_$ref_pketfb_1(view_9));
    reactiveScope(view_9, ($this$reactiveScope) => {
      var tmp$ret$54 = 'Description: ' + $this$reactiveScope.baj(scope).n7z_1;
      this_3.set(tmp$ret$54);
      return Unit_instance;
    });
    view.fbb(p_9, view_9);
    view.jbb(tmp_11, view_9);
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent = Indent_HalfSection_getInstance();
    var tmp2 = indent.ygq_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace = indent.zgq_1;
    var tmp_14 = get_unpadded(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_10 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_10 = view.cbb_1;
    var p_10 = tmp0_elvis_lhs_10 == null ? view : tmp0_elvis_lhs_10;
    view.ebb(p_10, view_10);
    var tmp_15;
    var tmp_16 = null;
    if (!((tmp_16 == null ? null : new (Dimension())(tmp_16)) == null)) {
      tmp_15 = sizeConstraints(view_10, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_15 = Companion_getInstance_0();
    }
    var tmp_17 = view_10.ibb(tmp_15, indented(view_10, tmp2, afterSpace));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_11 = new (RowOrCol())(view_10.pc());
    var tmp0_elvis_lhs_11 = view_10.cbb_1;
    var p_11 = tmp0_elvis_lhs_11 == null ? view_10 : tmp0_elvis_lhs_11;
    view_10.ebb(p_11, view_11);
    view_11.xbm(true);
    view_11.zb8(get_px(0));
    var tmp0_elvis_lhs_12 = ReactiveState__getOrNull_impl_1asnfp(groupId.qah());
    var tmp_18 = (tmp0_elvis_lhs_12 == null ? Companion_getInstance_1().m2p() : tmp0_elvis_lhs_12).toString() + '-items';
    var tmp_19 = EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_8(this$0, scope);
    forEachMaybeReorderableDestroying(view_11, topLevelItems, tmp_18, tmp_19, VOID, VOID, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$lambda_i1hp8_0);
    view_10.fbb(p_11, view_11);
    view_10.jbb(tmp_17, view_11);
    view.fbb(p_10, view_10);
    view.jbb(tmp_14, view_10);
    var anySubs = lens(subscopes, EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$lambda_i1hp8_1);
    var tmp_20 = shownWhen(view, VOID, ($this$shownWhen) => $this$shownWhen.baj(anySubs));
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var indent_0 = Indent_HalfSection_getInstance();
    var tmp2_0 = indent_0.ygq_1;
    // Inline function 'com.crowpay.views.components.indentedCol' call
    var afterSpace_0 = indent_0.zgq_1;
    var tmp_21 = get_unpadded(view);
    // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_12 = new (Frame())(view.pc());
    var tmp0_elvis_lhs_13 = view.cbb_1;
    var p_12 = tmp0_elvis_lhs_13 == null ? view : tmp0_elvis_lhs_13;
    view.ebb(p_12, view_12);
    var tmp_22;
    var tmp_23 = null;
    if (!((tmp_23 == null ? null : new (Dimension())(tmp_23)) == null)) {
      tmp_22 = sizeConstraints(view_12, VOID, VOID, VOID, VOID, VOID, null);
    } else {
      tmp_22 = Companion_getInstance_0();
    }
    var tmp_24 = view_12.ibb(tmp_22, indented(view_12, tmp2_0, afterSpace_0));
    // Inline function 'com.lightningkite.kiteui.views.direct.col' call
    // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
    var view_13 = new (RowOrCol())(view_12.pc());
    var tmp0_elvis_lhs_14 = view_12.cbb_1;
    var p_13 = tmp0_elvis_lhs_14 == null ? view_12 : tmp0_elvis_lhs_14;
    view_12.ebb(p_13, view_13);
    view_13.xbm(true);
    var $this$indentedCol = view_13;
    reactive($this$indentedCol, ($this$reactive) => {
      $this$indentedCol.zb9();
      var tmp;
      if ($this$reactive.baj(anySubs)) {
        var tmp0_elvis_lhs = ReactiveState__getOrNull_impl_1asnfp(groupId.qah());
        render$_anonymous_$_anonymous_$renderGroups_5lnnq($this$indentedCol, this$0, subscopes, (tmp0_elvis_lhs == null ? Companion_getInstance_1().m2p() : tmp0_elvis_lhs).toString() + '-groups', false);
        tmp = Unit_instance;
      }
      return Unit_instance;
    });
    view_12.fbb(p_13, view_13);
    view_12.jbb(tmp_24, view_13);
    view.fbb(p_12, view_12);
    var tmp$ret$78 = view.jbb(tmp_21, view_12);
    view.jbb(tmp_20, tmp$ret$78);
    $this$forEachMaybeReorderable.fbb(p, view);
    return view;
  });
  _this__u8e3s4.fbb(p, view);
}
function *_generator_render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet__rpbmn4(_this__u8e3s4, this$0, $completion) {
  var tmp;
  if (_this__u8e3s4.p7z_1) {
    tmp = _this__u8e3s4.k7z_1;
  } else {
    var tmp0_safe_receiver = _this__u8e3s4.q7z_1;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'com.lightningkite.reactive.context.invoke' call
      var this_0 = this$0.jho_1;
      var tmp_1 = await_0(this_0, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      // Inline function 'kotlin.collections.find' call
      var tmp0 = tmp_1;
      var tmp$ret$2;
      $l$block: {
        // Inline function 'kotlin.collections.firstOrNull' call
        var _iterator__ex2g4s = tmp0.m1();
        while (_iterator__ex2g4s.n1()) {
          var element = _iterator__ex2g4s.o1();
          if (element.k7z_1.equals(tmp0_safe_receiver)) {
            tmp$ret$2 = element;
            break $l$block;
          }
        }
        tmp$ret$2 = null;
      }
      var tmp0_safe_receiver_0 = tmp$ret$2;
      var tmp_2;
      if (tmp0_safe_receiver_0 == null) {
        tmp_2 = null;
      } else {
        var tmp_3 = render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_8ypbvc(tmp0_safe_receiver_0, this$0, $completion);
        if (tmp_3 === get_COROUTINE_SUSPENDED())
          tmp_3 = yield tmp_3;
        tmp_2 = tmp_3;
      }
      tmp_0 = tmp_2;
    }
    tmp = tmp_0;
  }
  return tmp;
}
function render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet_8ypbvc(_this__u8e3s4, this$0, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_render$_anonymous_$_anonymous_$renderGroups$_anonymous_$_anonymous_$_anonymous_$_anonymous_$scopeSet__rpbmn4.bind(VOID, _this__u8e3s4, this$0), $completion);
}
var EditLineItems$_init_$slambda_4qw03aClass;
function EditLineItems$_init_$slambda_4qw03a() {
  if (EditLineItems$_init_$slambda_4qw03aClass === VOID) {
    class $ {
      whq(it, $completion) {
        return Unit_instance;
      }
      s2(p1, $completion) {
        return this.whq((p1 == null ? true : p1 instanceof LineItem()) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$_init_$slambda_4qw03aClass = $;
  }
  return EditLineItems$_init_$slambda_4qw03aClass;
}
function EditLineItems$_init_$slambda_4qw03a_0() {
  var i = new (EditLineItems$_init_$slambda_4qw03a())();
  var l = (it, $completion) => i.whq(it, $completion);
  l.$arity = 1;
  return l;
}
function EditLineItems$sorted$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  var tmp = a.bf_1;
  var tmp$ret$1 = b.bf_1;
  return compareValues(tmp, tmp$ret$1);
}
var EditLineItems$sort$slambdaClass;
function EditLineItems$sort$slambda() {
  if (EditLineItems$sort$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.xhq_1 = this$0;
      }
      qho(it, $completion) {
        return sorted_0(this.xhq_1, it, $completion);
      }
      s2(p1, $completion) {
        return this.qho((!(p1 == null) ? isInterface(p1, KtList()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$sort$slambdaClass = $;
  }
  return EditLineItems$sort$slambdaClass;
}
function EditLineItems$sort$slambda_0(this$0) {
  var i = new (EditLineItems$sort$slambda())(this$0);
  var l = (it, $completion) => i.qho(it, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItems$forms$slambdaClass;
function EditLineItems$forms$slambda() {
  if (EditLineItems$forms$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.mho_1 = this$0;
      }
      wah($this$mutableRememberSuspending, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this, $this$mutableRememberSuspending), $completion);
      }
      s2(p1, $completion) {
        return this.wah((!(p1 == null) ? isInterface(p1, CoroutineScope()) : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$forms$slambdaClass = $;
  }
  return EditLineItems$forms$slambdaClass;
}
function EditLineItems$forms$slambda_0(this$0) {
  var i = new (EditLineItems$forms$slambda())(this$0);
  var l = ($this$mutableRememberSuspending, $completion) => i.wah($this$mutableRememberSuspending, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItems$reorderForms$slambdaClass;
function EditLineItems$reorderForms$slambda() {
  if (EditLineItems$reorderForms$slambdaClass === VOID) {
    class $ {
      constructor($mod) {
        this.yhq_1 = $mod;
      }
      bgy(it, $completion) {
        return this.yhq_1.t3q(it);
      }
      s2(p1, $completion) {
        return this.bgy(p1 instanceof LineItem() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$reorderForms$slambdaClass = $;
  }
  return EditLineItems$reorderForms$slambdaClass;
}
function EditLineItems$reorderForms$slambda_0($mod) {
  var i = new (EditLineItems$reorderForms$slambda())($mod);
  var l = (it, $completion) => i.bgy(it, $completion);
  l.$arity = 1;
  return l;
}
var EditLineItems$createForm$slambdaClass;
function EditLineItems$createForm$slambda() {
  if (EditLineItems$createForm$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.pho_1 = this$0;
      }
      zhq($this$EditLineItem, formId, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this, $this$EditLineItem, formId), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ViewWriter() ? p1 : THROW_CCE();
        return this.zhq(tmp, p2 instanceof UUID() ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditLineItems$createForm$slambdaClass = $;
  }
  return EditLineItems$createForm$slambdaClass;
}
function EditLineItems$createForm$slambda_0(this$0) {
  var i = new (EditLineItems$createForm$slambda())(this$0);
  var l = ($this$EditLineItem, formId, $completion) => i.zhq($this$EditLineItem, formId, $completion);
  l.$arity = 2;
  return l;
}
function Button$_get_enabled_$ref_61t7nx(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var EditLineItems$render$slambdaClass;
function EditLineItems$render$slambda() {
  if (EditLineItems$render$slambdaClass === VOID) {
    class $ {
      constructor(this$0) {
        this.rho_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$slambdaClass = $;
  }
  return EditLineItems$render$slambdaClass;
}
function EditLineItems$render$slambda_0(this$0) {
  var i = new (EditLineItems$render$slambda())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function Button$_get_enabled_$ref_61t7nx_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.disabled;
    return !(((!(tmp == null) ? typeof tmp === 'boolean' : false) ? tmp : null) === true);
  };
}
function Button$_set_enabled_$ref_o8kynz_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.Button.enabled' call
    var tmp0 = p0.tb5_1.zb3_1;
    // Inline function 'com.lightningkite.kiteui.views.disabled' call
    var value = !_this__u8e3s4;
    tmp0.ib7_1.disabled = value;
    return Unit_instance;
  };
}
var EditLineItems$render$slambdaClass_0;
function EditLineItems$render$slambda_1() {
  if (EditLineItems$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.sho_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_3.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$slambdaClass_0 = $;
  }
  return EditLineItems$render$slambdaClass_0;
}
function EditLineItems$render$slambda_2(this$0) {
  var i = new (EditLineItems$render$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItems$render$slambdaClass_1;
function EditLineItems$render$slambda_3() {
  if (EditLineItems$render$slambdaClass_1 === VOID) {
    class $ {
      constructor(this$0) {
        this.ahp_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_5.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$slambdaClass_1 = $;
  }
  return EditLineItems$render$slambdaClass_1;
}
function EditLineItems$render$slambda_4(this$0) {
  var i = new (EditLineItems$render$slambda_3())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItems$render$slambdaClass_2;
function EditLineItems$render$slambda_5() {
  if (EditLineItems$render$slambdaClass_2 === VOID) {
    class $ {
      constructor(this$0) {
        this.dhp_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_7.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$slambdaClass_2 = $;
  }
  return EditLineItems$render$slambdaClass_2;
}
function EditLineItems$render$slambda_6(this$0) {
  var i = new (EditLineItems$render$slambda_5())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItems$render$slambdaClass_3;
function EditLineItems$render$slambda_7() {
  if (EditLineItems$render$slambdaClass_3 === VOID) {
    class $ {
      constructor(this$0) {
        this.ghp_1 = this$0;
      }
      dhm(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_8.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$slambdaClass_3 = $;
  }
  return EditLineItems$render$slambdaClass_3;
}
function EditLineItems$render$slambda_8(this$0) {
  var i = new (EditLineItems$render$slambda_7())(this$0);
  var l = (it, $completion) => i.dhm(it, $completion);
  l.$arity = 1;
  return l;
}
function EditLineItems$render$lambda($this$forEachMaybeReorderableDestroying, form, dragData) {
  var tmp = indentedExact($this$forEachMaybeReorderableDestroying, get_px(7), get_px(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachMaybeReorderableDestroying.pc());
  var tmp0_elvis_lhs = $this$forEachMaybeReorderableDestroying.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderableDestroying : tmp0_elvis_lhs;
  $this$forEachMaybeReorderableDestroying.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  // Inline function 'kotlin.with' call
  form.cho(view, dragData);
  greySeparator(view);
  $this$forEachMaybeReorderableDestroying.fbb(p, view);
  return $this$forEachMaybeReorderableDestroying.jbb(tmp, view);
}
function EditLineItems$render$lambda_0(it) {
  return it.q7z_1 == null;
}
var EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyhClass;
function EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyh() {
  if (EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyhClass === VOID) {
    class $ {
      constructor($this$0) {
        this.hhp_1 = $this$0;
      }
      jhq(scope, selected, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_9.bind(VOID, this, scope, selected), $completion);
      }
      rd(p1, p2, $completion) {
        var tmp = p1 instanceof ScopeView() ? p1 : THROW_CCE();
        return this.jhq(tmp, (!(p2 == null) ? isInterface(p2, KtList()) : false) ? p2 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [2]);
    EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyhClass = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyhClass;
}
function EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyh_0($this$0) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$createScopeView$slambda_777oyh())($this$0);
  var l = (scope, selected, $completion) => i.jhq(scope, selected, $completion);
  l.$arity = 2;
  return l;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejqClass;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejq() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejqClass === VOID) {
    class $ {
      constructor($groups) {
        this.jhp_1 = $groups;
      }
      dhm(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_10.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejqClass = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejqClass;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejq_0($groups) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$slambda_o5iejq())($groups);
  var l = (it, $completion) => i.dhm(it, $completion);
  l.$arity = 1;
  return l;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$lambda_i1hp8(it) {
  return it.k7z_1;
}
function IconView$_get_dragData_$ref_4jg2ny(p0) {
  return () => p0.hb9();
}
function IconView$_set_dragData_$ref_k36t82(p0) {
  return (_this__u8e3s4) => {
    p0.gb9(_this__u8e3s4);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
function TextView$_get_content_$ref_4pzcwl_0(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_0(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass === VOID) {
    class $ {
      constructor($scope, $this$0) {
        this.qhp_1 = $scope;
        this.rhp_1 = $this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_12.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_0($scope, $this$0) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp())($scope, $this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_0;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_1() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_0 === VOID) {
    class $ {
      constructor($$this$button, $subscopes, $allItems, $scope) {
        this.whp_1 = $$this$button;
        this.xhp_1 = $subscopes;
        this.yhp_1 = $allItems;
        this.zhp_1 = $scope;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_14.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_0 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_0;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_2($$this$button, $subscopes, $allItems, $scope) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_1())($$this$button, $subscopes, $allItems, $scope);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_1;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_3() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_1 === VOID) {
    class $ {
      constructor($scope, $this$0, $allItems, $topLevelItems) {
        this.fhq_1 = $scope;
        this.ghq_1 = $this$0;
        this.hhq_1 = $allItems;
        this.ihq_1 = $topLevelItems;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_16.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_1 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_1;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_4($scope, $this$0, $allItems, $topLevelItems) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_3())($scope, $this$0, $allItems, $topLevelItems);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_2;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_5() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_2 === VOID) {
    class $ {
      constructor($scope, $subscopes, $this$0) {
        this.phq_1 = $scope;
        this.qhq_1 = $subscopes;
        this.rhq_1 = $this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_18.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_2 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_2;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_6($scope, $subscopes, $this$0) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_5())($scope, $subscopes, $this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function TextView$_get_content_$ref_4pzcwl_1(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp0_elvis_lhs = p0.tb5_1.jb4_1;
    return tmp0_elvis_lhs == null ? '' : tmp0_elvis_lhs;
  };
}
function TextView$_set_content_$ref_pketfb_1(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.TextView.content' call
    var tmp = p0.tb5_1;
    var tmp_0;
    // Inline function 'kotlin.text.isEmpty' call
    if (charSequenceLength(_this__u8e3s4) === 0) {
      tmp_0 = '\xA0';
    } else {
      tmp_0 = _this__u8e3s4;
    }
    tmp.fbu(tmp_0);
    return Unit_instance;
  };
}
var EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_3;
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_7() {
  if (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_3 === VOID) {
    class $ {
      constructor($this$0, $scope) {
        this.shq_1 = $this$0;
        this.thq_1 = $scope;
      }
      dhm(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_19.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.dhm(p1 instanceof Move() ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_3 = $;
  }
  return EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlpClass_3;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_8($this$0, $scope) {
  var i = new (EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$slambda_l7gzlp_7())($this$0, $scope);
  var l = (it, $completion) => i.dhm(it, $completion);
  l.$arity = 1;
  return l;
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$lambda_i1hp8_0($this$forEachMaybeReorderableDestroying, form, dragData) {
  var tmp = indentedExact($this$forEachMaybeReorderableDestroying, get_px(7), get_px(1));
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (RowOrCol())($this$forEachMaybeReorderableDestroying.pc());
  var tmp0_elvis_lhs = $this$forEachMaybeReorderableDestroying.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$forEachMaybeReorderableDestroying : tmp0_elvis_lhs;
  $this$forEachMaybeReorderableDestroying.ebb(p, view);
  view.xbm(true);
  view.zb8(get_px(0));
  // Inline function 'kotlin.with' call
  form.cho(view, dragData);
  greySeparator(view);
  $this$forEachMaybeReorderableDestroying.fbb(p, view);
  return $this$forEachMaybeReorderableDestroying.jbb(tmp, view);
}
function EditLineItems$render$_anonymous_$_anonymous_$renderGroups$lambda$lambda_i1hp8_1(it) {
  // Inline function 'kotlin.collections.isNotEmpty' call
  return !it.i1();
}
var EditLineItemsClass;
function EditLineItems() {
  if (EditLineItemsClass === VOID) {
    class $ {
      constructor(projectId, allowSave, reportTo, validateWhen, onSave) {
        allowSave = allowSave === VOID ? new (Constant())(_Constant___init__impl__v45mub(true)) : allowSave;
        reportTo = reportTo === VOID ? null : reportTo;
        var tmp;
        if (onSave === VOID) {
          tmp = EditLineItems$_init_$slambda_4qw03a_0();
        } else {
          tmp = onSave;
        }
        onSave = tmp;
        this.dho_1 = projectId;
        this.eho_1 = allowSave;
        this.fho_1 = reportTo;
        this.gho_1 = validateWhen;
        this.hho_1 = onSave;
        var tmp_0 = this;
        tmp_0.iho_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp = $this$remember.baj(get_session()).ufv_1;
          // Inline function 'com.lightningkite.lightningdb.condition' call
          // Inline function 'com.lightningkite.lightningdb.path' call
          // Inline function 'com.lightningkite.serialization.serializerOrContextual' call
          var tmp_0 = serializerOrContextual(createKType(getKClass(ScopeView()), arrayOf([]), false));
          var tmp$ret$0 = isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
          // Inline function 'kotlin.let' call
          var it = new (DataClassPathSelf())(tmp$ret$0);
          var tmp$ret$4 = eq(get_project_0(it), this.dho_1);
          return tmp.kdw(new (Query())(tmp$ret$4, VOID, VOID, 2147483647));
        });
        var tmp_1 = this;
        tmp_1.jho_1 = remember(VOID, VOID, VOID, ($this$remember) => sorted($this$remember.baj($this$remember.baj(this.iho_1))));
        var tmp_2 = this;
        tmp_2.kho_1 = mutableRememberSuspending(VOID, VOID, EditLineItems$forms$slambda_0(this));
        var tmp_3 = this;
        tmp_3.lho_1 = remember(VOID, VOID, VOID, ($this$remember) => {
          var tmp0 = $this$remember.baj(this.kho_1);
          var tmp$ret$5;
          $l$block_0: {
            // Inline function 'kotlin.collections.all' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$5 = true;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if (!$this$remember.baj(element.ihn_1)) {
                tmp$ret$5 = false;
                break $l$block_0;
              }
            }
            tmp$ret$5 = true;
          }
          return tmp$ret$5;
        });
      }
      ug9() {
        return this.lho_1;
      }
      nho(line) {
        var tmp0_projectId = this.dho_1;
        var tmp1_allowSave = this.eho_1;
        var tmp2_reportTo = this.fho_1;
        var tmp3_validateWhen = this.gho_1;
        var tmp4_onSave = this.hho_1;
        return new (EditLineItem())(line, tmp0_projectId, tmp2_reportTo, tmp3_validateWhen, tmp1_allowSave, EditLineItems$createForm$slambda_0(this), tmp4_onSave);
      }
      vho($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_hasUnsavedChanges__b8k745.bind(VOID, this), $completion);
      }
      uho($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_hasNoLineItems__a80iix.bind(VOID, this), $completion);
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        if (get_viewIsWide(view)) {
          get_atEnd(view);
        }
        // Inline function 'com.lightningkite.kiteui.views.direct.rowCollapsingToColumn' call
        var breakpoint = get_AppDimensions().gg2_1;
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (RowCollapsingToColumn())(view.pc(), listOf(new (Dimension())(breakpoint)));
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_1 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_1 = view_0.cbb_1;
        var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
        view_0.ebb(p_1, view_1);
        view_1.xbm(false);
        var tmp = view_1.ibb(render$_anonymous_$_anonymous_$expandIfNarrow_h26h72(view_1), get_secondaryButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_2 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_2 = view_1.cbb_1;
        var p_2 = tmp0_elvis_lhs_2 == null ? view_1 : tmp0_elvis_lhs_2;
        view_1.ebb(p_2, view_2);
        specCenteredText(view_2, '+ Scope Set');
        var tmp_0 = KMutableProperty0();
        var tmp_1 = Button$_get_enabled_$ref_61t7nx(view_2);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_0 = getPropertyCallableRef('enabled', 0, tmp_0, tmp_1, Button$_set_enabled_$ref_o8kynz(view_2));
        reactiveScope(view_2, ($this$reactiveScope) => {
          var tmp0 = $this$reactiveScope.baj(this.kho_1);
          var tmp$ret$0;
          $l$block_0: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$0 = false;
              break $l$block_0;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if ($this$reactiveScope.baj(element.chn_1).j6k_1 == null) {
                tmp$ret$0 = true;
                break $l$block_0;
              }
            }
            tmp$ret$0 = false;
          }
          var tmp$ret$2 = tmp$ret$0;
          this_0.set(tmp$ret$2);
          return Unit_instance;
        });
        onClick(view_2, VOID, VOID, EditLineItems$render$slambda_0(this));
        view_1.fbb(p_2, view_2);
        view_1.jbb(tmp, view_2);
        var tmp_2 = view_1.ibb(render$_anonymous_$_anonymous_$expandIfNarrow_h26h72(view_1), get_secondaryButton(view_1));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_1.pc());
        var tmp0_elvis_lhs_3 = view_1.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_1 : tmp0_elvis_lhs_3;
        view_1.ebb(p_3, view_3);
        specCenteredText(view_3, '+ Scope View');
        var tmp_3 = KMutableProperty0();
        var tmp_4 = Button$_get_enabled_$ref_61t7nx_0(view_3);
        // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
        var this_1 = getPropertyCallableRef('enabled', 0, tmp_3, tmp_4, Button$_set_enabled_$ref_o8kynz_0(view_3));
        reactiveScope(view_3, ($this$reactiveScope) => {
          var tmp0 = $this$reactiveScope.baj(this.kho_1);
          var tmp$ret$7;
          $l$block_2: {
            // Inline function 'kotlin.collections.any' call
            var tmp;
            if (isInterface(tmp0, Collection())) {
              tmp = tmp0.i1();
            } else {
              tmp = false;
            }
            if (tmp) {
              tmp$ret$7 = false;
              break $l$block_2;
            }
            var _iterator__ex2g4s = tmp0.m1();
            while (_iterator__ex2g4s.n1()) {
              var element = _iterator__ex2g4s.o1();
              if ($this$reactiveScope.baj(element.chn_1).j6k_1 == null) {
                tmp$ret$7 = true;
                break $l$block_2;
              }
            }
            tmp$ret$7 = false;
          }
          var tmp$ret$9 = tmp$ret$7;
          this_1.set(tmp$ret$9);
          return Unit_instance;
        });
        onClick(view_3, VOID, VOID, EditLineItems$render$slambda_2(this));
        view_1.fbb(p_3, view_3);
        view_1.jbb(tmp_2, view_3);
        view_0.fbb(p_1, view_1);
        // Inline function 'com.lightningkite.kiteui.views.direct.row' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_4 = new (RowOrCol())(view_0.pc());
        var tmp0_elvis_lhs_4 = view_0.cbb_1;
        var p_4 = tmp0_elvis_lhs_4 == null ? view_0 : tmp0_elvis_lhs_4;
        view_0.ebb(p_4, view_4);
        view_4.xbm(false);
        var tmp_5 = view_4.ibb(render$_anonymous_$_anonymous_$expandIfNarrow_h26h72(view_4), get_tertiaryButton(view_4));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_5 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_5 = view_4.cbb_1;
        var p_5 = tmp0_elvis_lhs_5 == null ? view_4 : tmp0_elvis_lhs_5;
        view_4.ebb(p_5, view_5);
        specCenteredText(view_5, '+ From Specs');
        onClick(view_5, VOID, VOID, EditLineItems$render$slambda_4(this));
        view_4.fbb(p_5, view_5);
        view_4.jbb(tmp_5, view_5);
        var tmp_6 = view_4.ibb(render$_anonymous_$_anonymous_$expandIfNarrow_h26h72(view_4), get_tertiaryButton(view_4));
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_6 = new (Button())(view_4.pc());
        var tmp0_elvis_lhs_6 = view_4.cbb_1;
        var p_6 = tmp0_elvis_lhs_6 == null ? view_4 : tmp0_elvis_lhs_6;
        view_4.ebb(p_6, view_6);
        specCenteredText(view_6, '+ New Work Item');
        onClick(view_6, VOID, VOID, EditLineItems$render$slambda_6(this));
        view_4.fbb(p_6, view_6);
        view_4.jbb(tmp_6, view_6);
        view_0.fbb(p_4, view_4);
        view.fbb(p_0, view_0);
        // Inline function 'com.lightningkite.kiteui.views.direct.space' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_7 = new (Space())(view.pc());
        var tmp0_elvis_lhs_7 = view.cbb_1;
        var p_7 = tmp0_elvis_lhs_7 == null ? view : tmp0_elvis_lhs_7;
        view.ebb(p_7, view_7);
        view.fbb(p_7, view_7);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_8 = new (RowOrCol())(view.pc());
        var tmp0_elvis_lhs_8 = view.cbb_1;
        var p_8 = tmp0_elvis_lhs_8 == null ? view : tmp0_elvis_lhs_8;
        view.ebb(p_8, view_8);
        view_8.xbm(true);
        view_8.zb8(get_px(0));
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_9 = new (RowOrCol())(view_8.pc());
        var tmp0_elvis_lhs_9 = view_8.cbb_1;
        var p_9 = tmp0_elvis_lhs_9 == null ? view_8 : tmp0_elvis_lhs_9;
        view_8.ebb(p_9, view_9);
        view_9.xbm(true);
        view_9.zb8(get_px(0));
        var tmp_7 = remember(VOID, VOID, VOID, ($this$remember) => {
          // Inline function 'kotlin.collections.filter' call
          var tmp0 = $this$remember.baj(this.kho_1);
          // Inline function 'kotlin.collections.filterTo' call
          var destination = ArrayList().w();
          var _iterator__ex2g4s = tmp0.m1();
          while (_iterator__ex2g4s.n1()) {
            var element = _iterator__ex2g4s.o1();
            if ($this$remember.baj(element.dhn_1) == null) {
              destination.v(element);
            }
          }
          return destination;
        });
        var tmp_8 = EditLineItems$render$slambda_8(this);
        forEachMaybeReorderableDestroying(view_9, tmp_7, 'individual', tmp_8, VOID, VOID, EditLineItems$render$lambda);
        view_8.fbb(p_9, view_9);
        get_compact(view_8);
        render$_anonymous_$_anonymous_$renderGroups_5lnnq(view_8, this, lensFilter(this.jho_1, EditLineItems$render$lambda_0), 'scopes', true);
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
        Companion_getInstance_0();
        view.fbb(p_8, view_8);
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'EditLineItems', VOID, VOID, [Page(), Form()], [1, 2, 0]);
    EditLineItemsClass = $;
  }
  return EditLineItemsClass;
}
//region block: exports
export {
  EditLineItems as EditLineItemspeyge9v529c9,
};
//endregion

//# sourceMappingURL=EditLineItems.mjs.map
